/**
 * 找样详情
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import {Modal} from "antd";
import "./index.less";
import dayjs from 'dayjs';
import {symbolMoneyUtil} from '@utils/utils';
import { loadImage } from "@utils/image-func";
import Lang from "@components/Lang/Lang";
class Info extends React.Component{
    constructor(props) {
        super(props);
    }

    openImg(item){
        Modal.info({
            width: 548,
            title:false,
            icon:<i></i>,
            //这个方法无法控制按钮，故通过样式的方式屏蔽下方按钮。
            className:"modal-big-wrap",
            closable:true,
            content:<div style={{width: '500px',height: '500px',display: 'flex', alignItems: 'center',justifyContent: 'center'}}>
                <img style={{maxWidth:'500px',maxHeight:'500px'}} src={item.url}/>
            </div>
        });
    }

    render(){
        const {model={}} = this.props;
        const {buyerVO = {}} = model;
        return (
            <div className="fuzzy-info__wrap">
                <div className="fuzzy-info__main">
                    <div className="font-weight-bold color089 font_18 mb_8">#{model.id} {__getServerLanguage('ZhaoYangXiangQing')}</div>
                    <div className="flex-box">
                        <div className="flex-box">
                            {
                                (model.fileList||[]).map((item,index)=>{
                                    return <div className="mr_12 cursor-p" key={index} onClick={this.openImg.bind(this,item)}>
                                        <img src={item.url} className="img" alt=""/>
                                        <p className="text">{index==0?__getServerLanguage('ZhengMian'):__getServerLanguage('BeiMian')}</p>
                                    </div>
                                })
                            }
                        </div>
                        <div className="flex-1">
                            <div className="fuzzy-info__label-wrap">
                                {
                                    model.isAccurate?
                                        <span>
                                            <i className="ri-checkbox-circle-fill"></i>
                                            <span className="color089 font_14">
                                                {Lang({id:'BiXuYuTuPianYiZhi',default:'必须与图片一致'})}
                                            </span>
                                        </span>
                                        :
                                        null
                                }
                                {
                                    model.isNeedCertificate?
                                        <span>
                                            <i className="ri-checkbox-circle-fill"></i>
                                            <span className="color089 font_14">
                                                {Lang({id:'BiXuDaiZhengShu',default:'必须带证书'})}
                                            </span>
                                        </span>
                                        :
                                        null
                                }
                                {
                                    model.priceMax?
                                        <span>
                                            <i className="ri-checkbox-circle-fill"></i>
                                            <span className="color089 font_14">
                                                {Lang({id:'DiYu',default:'低于 {0}',params:[`${symbolMoneyUtil(model.priceMax,buyerVO.currencySymbol)}`]})}
                                            </span>
                                        </span>: null
                                }
                                {
                                    model.purchaseQuantity?
                                        <span>
                                            <i className="ri-checkbox-circle-fill"></i>
                                            <span className="color089 font_14">
                                                {Lang({id:'YuJiCaiGou',default:'预计采购 {0} PCS',params:[model.purchaseQuantity]})}
                                            </span>
                                        </span>:
                                        null
                                }
                            </div>
                            <div>
                                <div className="color089 font_14 lineH_150p">{model.subject||'-'}</div>
                                <div className="color066 font_14 lineH_150p mt_8">
                                    {Lang({id:'YiWen',default:'译文'})}：{model.subjectZh||'-'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex-box align-items-center ant-row-flex-space-between mt_8">
                    <div className="color066 font_14">
                        {model.createTime?dayjs(model.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}
                        {model.createByUserName?<span className={"ml_12"}>
                            {Lang({id:'DengJiRen',default:'登记人'})}：
                            {model.createByUserName||"-"}
                        </span>:null}
                    </div>
                    <div className="color066 font_14">
                        {Lang({id:'DangQianRenWuGenJin',default:'当前任务跟进'})}：{model.recommendUserName||'-'}
                    </div>
                </div>
            </div>
        )
    }
}

Info.defaultProps = {
    fuzzyId:null,
    model:{},
}

Info.propTypes = {

}
export default Info;
